import { Checklist, ChecklistDto } from '../types/workflow.types'

export const mapChecklistDto = (checklist: ChecklistDto): Checklist => {
  return {
    id: checklist.id,
    checklist: checklist.checkResult,
    objectId: checklist.du,
    comment: checklist.comment,
    status: checklist.status,
    milestoneId: checklist.milestone,
    factStart: checklist.factStart ? new Date(checklist.factStart) : null,
    factFinish: checklist.factFinish ? new Date(checklist.factFinish) : null,
    responsibleId: checklist.responsibleId,
    isResponsibleInvited: checklist.isResponsibleInvited ?? false,
  }
}

export const mapChecklistSaveDto = (checklist: Partial<Checklist>): Partial<ChecklistDto> => {
  return {
    checkResult: checklist.checklist,
    du: checklist.objectId,
    comment: checklist.comment ?? {},
    status: checklist.status,
    milestone: checklist.milestoneId,
  }
}
